import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useModals } from '@mattjennings/react-modal-stack';
import { URL_PREFIX } from '../api';
import ImagePickerModal from '../components/ImagePickerModal';
import { DataContainer } from '../components/DataContainer';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { fetchAll, ensureAll, toggleFoodPackageHidden, update as updateFoodPackage } from '../store/foodPackagesSlice';



function FoodPackageModal({ open, id }) {
    id = id.toUpperCase();
    const { closeModal, openModal } = useModals();
    const dispatch = useDispatch();
    const [ name, setName ] = useState('');
    const [ description, setDescription ] = useState('');
    const [ price, setPrice ] = useState('');
    const [ hidden, setHidden ] = useState(false);
    const user = useSelector((state) => state.user.data);

    const _foodPackages = useSelector((state) => state.foodPackages.knownFoodPackages);
    const foodPackage = _foodPackages[id];

    console.log(_foodPackages);

    useEffect(() => {(async () => {
        await dispatch(ensureAll());
    })()}, []);

    useEffect(() => {
        if(!foodPackage) return;
        setName(foodPackage["food_package_name"]);
        setDescription(foodPackage["food_package_description"]);
        setPrice(foodPackage["food_package_price"]);
        setHidden(foodPackage["food_package_hidden"]);
    }, [foodPackage]);

    function onSave() {
        dispatch(updateFoodPackage({
            id, name, description, price
        }));
        dispatch(fetchAll());
    }

    async function toggleHidden() {
        const wasHidden = hidden;
        const res = await unwrapResult(await dispatch(toggleFoodPackageHidden({ id, hidden: !hidden })));
        if(!res) return;

        closeModal();

        toast.success(`Toidupakk ${wasHidden ? 'nähtavaks tehtud!' : 'peidetud!'}`);
    }

    if(!(id in _foodPackages)) return null;

    if (!open) return null;
  
    return (
        <div className='modal'>
            <div className='container column'>
                <DataContainer actionType={'foodPackages/fetchAll'} >
                    
                    <div className="column p16 g16">

                        <div className="row g16">
                            <h2 className='grow'>{foodPackage.food_package_name}</h2>

                            <button
                                onClick={() => {
                                    dispatch(fetchAll());
                                    closeModal();
                                }}
                                style={{
                                    padding: 8,
                                }}
                            >
                                <svg height="12" width="12" xmlns="http://www.w3.org/2000/svg" fill="#666" version="1.1" id="Capa_1" viewBox="0 0 490 490" >
                                    <polygon points="456.851,0 245,212.564 33.149,0 0.708,32.337 212.669,245.004 0.708,457.678 33.149,490 245,277.443 456.851,490   489.292,457.678 277.331,245.004 489.292,32.337 "/>
                                </svg>
                            </button>

                        </div>
                        
                        <div className="column g8">
                            <img
                                src={URL_PREFIX + "/storage/food_package/"+foodPackage.food_package_id.toLowerCase()+".jpg"}
                                style={{ borderRadius: 8, backgroundColor: '#ddd', objectFit: 'contain', height: 240 }}
                            />
                            { user.role == "admin" && (
                                <button onClick={() => openModal(ImagePickerModal, { title: foodPackage.food_package_name, url: `/foodPackage/${id}/photo`, callback: () => dispatch(fetchAll()) })}>Muuda pilti</button>
                            ) }
                            { user.role == "admin" && (
                                <button onClick={toggleHidden} style={hidden ? {} : { backgroundColor: '#d4635b', borderColor: '#f4837b', color: '#fff' }}>
                                    {hidden ? "Too tagasi" : "Peida"}
                                </button>
                            ) }
                        </div>
                    
                    </div>

                    { user.role == "admin" && (
                        <>
                            <div className="hr"></div>
                            
                            <div className="column p32 g16">

                                <h3>Andmed</h3>
                                
                                <DataContainer actionType={'foodPackages/update'} >
                                    <div className="column g4">
                                        <b>Nimi</b>
                                        <input type="text" value={name} onChange={e => setName(e.target.value)} />
                                    </div>

                                    <div className="column g4">
                                        <b>Kirjeldus</b>
                                        <input type="text" value={description} onChange={e => setDescription(e.target.value)} />
                                    </div>

                                    <div className="column g4">
                                        <b>Hind</b>
                                        <input type="text" value={price} onChange={e => setPrice(e.target.value)} placeholder='0.00' />
                                    </div>
                                </DataContainer>

                                <button onClick={onSave}>Salvesta</button>
                            </div>
                        </>
                    ) }
                </DataContainer>
            </div>
        </div>
    );
}

export default FoodPackageModal;